export const analyticsConfig = {
  gtmId: 'GTM-NT56NC66', // Your actual GTM container ID
  gaId: 'G-4NX4YG74N7', // Keep for reference, but we'll use GTM now
  enabled: true,
  debug: true, // Enable debug mode to see tracking events in console
}; 